import { NgModule } from '@angular/core';
import { FilterPropCcraPerUsagePipe } from './filter-prop-ccra-per-usage.pipe';

@NgModule({
  declarations: [FilterPropCcraPerUsagePipe],
  imports: [],
  exports: [FilterPropCcraPerUsagePipe],
})
export class UsagesModule {}
